import { render } from "./OptStatViewManagerPatients.vue?vue&type=template&id=ff0a7610&scoped=true"
import script from "./OptStatViewManagerPatients.vue?vue&type=script&lang=js"
export * from "./OptStatViewManagerPatients.vue?vue&type=script&lang=js"

import "./OptStatViewManagerPatients.vue?vue&type=style&index=0&id=ff0a7610&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ff0a7610"]])

export default __exports__